<template>
  <div class="ad-wrapper ad-facility-review-top">
    <adsbygoogle
      :ad-style="gadStyle"
      ad-slot="9689640881"
      ad-format="fluid"
      ad-layout="in-article"
    />
  </div>
</template>

<script>
export default {
  data: () => ({
    gadStyle: {
      display: 'block',
      textAlign: 'center'
    }
  })
}
</script>
